import { Component } from '@angular/core';

@Component({
  selector: 'app-connection-unavailable-screen',
  standalone: true,
  templateUrl: './connection-unavailable-screen.component.html',
})
export class ConnectionUnavailableScreenComponent {
  readonly footerText = `© ${new Date().getFullYear()} smzh ag. Alle Rechte vorbehalten.`;
}
